// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"67":"37583c35ce01586dfa45","427":"c779a37026dece8a7219","625":"15d2708934b8ab6fded4"}[chunkId] + ".js";
};